import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import MyAccountTemplate from "../../sections/my-account-template";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import AccordionWrapper from "../../elements/order-accordion-wrapper-history";
import BodyText from "../../elements/body-text";

import { selectUserState, staffInfoSelector } from "../../selectors/application";

import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import { getDictionary } from "../../services/siteService";
import { dictTypes, orderTypes, planType } from "../../utils/lynkco-constants";
import storeApi from "../../utils/storeApi";
import api from "../../utils/api";
import { getLang, getOrderType } from "../../utils/processesOrderDetails";
import { format, MathUtils } from "../../utils";
import getSiteInfo from "../../utils/getSiteInfo";
import orderAllStatusQuery from "../../Graphql/queryOrderAllStatus.js";
import AllReceiptsTable from "../../sections/all-receipts-table";
import { appendQuery } from "../../utils/urlHelper";
import "./style.scss";

const MyAccountOrders = ({ rendering, fields, user, staffInfo, lang }) => {
  const { accountMenu, body, gearTemplate, goToPresalesButton, headingBody, headingType, hero, noOrderTitleType, noOrdersBody, noOrdersTitleBody, preorderTemplate, pdpTemplate, showMoreCTA } = fields;
  const { receiptsHeadingType, receiptsHeadingBody, receiptsBody, dateLabel, amountLabel, receiptsNumberLabel, invoiceLabel, receiptLabel, receiptLinkLabel, invoiceLinkLabel, numberOfReceiptToShow, showMoreReceiptsCTA, noReceiptsTitleType, noReceiptsBody, noReceiptsTitleBody } = fields;
  const { firstName } = user || {};
  const history = useHistory();
  const pageConfiguration = {
    heading: {
      html: headingBody,
      type: headingType || {
        type: { fields: { phrase: { value: "h3" } } }
      },
      typographyClass: "type-h3"
    },
    body: body.value,

    showMoreButton: {
      buttonText: showMoreCTA?.fields.link.value.text,
      iconName: showMoreCTA?.fields.iconName,
      icon: showMoreCTA?.fields.iconName.value.alt,
      colorScheme: showMoreCTA?.fields.colorScheme
    },
    noOrders: {
      heading: {
        html: noOrdersTitleBody,
        type: noOrderTitleType || {
          type: { fields: { phrase: { value: "h3" } } }
        }
      },
      body: noOrdersBody.value,
      cta: goToPresalesButton?.fields
    },
    noReceipts: {
      heading: {
        html: noReceiptsTitleBody,
        type: noReceiptsTitleType || {
          type: { fields: { phrase: { value: "h3" } } }
        }
      },
      body: noReceiptsBody?.value
    }
  };
  const receiptConfiguration = {
    heading: {
      html: receiptsHeadingBody,
      type: receiptsHeadingType || {
        type: { fields: { phrase: { value: "h3" } } }
      },
      typographyClass: "type-h3"
    },
    body: receiptsBody?.value,
    showMoreButton: {
      buttonText: showMoreReceiptsCTA?.fields.link.value.text,
      colorScheme: showMoreReceiptsCTA?.fields.colorScheme
    }
  };

  const [showMore, setShowMore] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersTotal, setOrdersTotal] = useState(100);
  const [isShowHaveNoOrder, setIsShowHaveNoOrder] = useState(false);
  const [bankCards, setBankCards] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [showMoreReceipts, setShowMoreReceipts] = useState(false);
  const [receiptsTotal, setTotalReceipts] = useState(10);

  const orderClasses = classNames("orders-container", {
    "no-orders": orders?.length <= 0 && isShowHaveNoOrder
  });
  const receiptClasses = classNames("my-account-orders-receipts", {
    "no-receipts": receipts?.length <= 0
  });
  const numberOfItems = showMore ? ordersTotal : 5;

  useEffect(() => {
    getOrders();
  }, [staffInfo]);

  useEffect(() => {
    getReceipts();
  }, []);

  const getGraphqlIcon = async () => {
    const query = orderAllStatusQuery(lang);
    const res = await api.graphql(null, { query: query });
    let _allStatus = [];
    if (!res?.data?.allStatus) {
      return _allStatus;
    }
    res.data.allStatus.children.forEach(type => {
      type.children.forEach(item => {
        _allStatus.push({
          svg: item.icon.alt,
          key: item.key.value
        });
      });
    });
    return _allStatus;
  };

  const getStatusByLang = (key, data) => {
    return data?.filter(x => x.dicCode === key)[0]?.languages[getLang(lang)]?.dicName;
  };
  const getOrders = async () => {
    const status = await getDictionary(dictTypes.orderStatus); //BF.get(["ORDERSTATUSTOC"]);
    const membershipLabels = await getDictionary(dictTypes.membership); //BF.get(["MEMBERSHIP"]);
    const delivermethods = await getDictionary(dictTypes.deliveryMethod);
    const orderTypesDict = await getDictionary(dictTypes.orderType);
    const siteInfo = await getSiteInfo();
    const allIcon = await getGraphqlIcon();
    let req = null;
    if (staffInfo) {
      req = storeApi.order.list(null, {
        customerAccount: user?.userAccount,
        displayLength: ordersTotal,
        displayStart: 0
      });
    } else {
      req = api.order.list(null, {
        displayLength: ordersTotal,
        displayStart: 0
      });
    }
    req
      .then(res => {
        if (res && res.obj) {
          let _orders = res.obj.data.map((item, index) => {
            const headingHtml = {
              value: orderTypesDict?.filter(x => x.dicCode === item?.subType)[0]?.languages[getLang(lang)]?.dicName
            };
            let language = item?.country ? `${item?.language}-${item?.country}` : item?.language;
            // let titlePrice = item?.subType === orderTypes?.monthToMonth ? item?.orderExtraData?.totalMonthlyFee : item.orderTotalFee;
            let titlePrice = item.orderTotalFee;
            return {
              orderId: item.id,
              orderNumber: item.orderNo,
              membershipLabels,
              delivermethods,
              open: index === 0,
              status: {
                text: getStatusByLang(item.orderStatusCode, status),
                code: item.orderStatusCode,
                icon: allIcon.filter(icon => icon.key === item.orderStatusCode)[0]
              },
              heading: {
                html: headingHtml,
                type: { fields: { phrase: { value: "h4" } } },
                typographyClass: "type-h4"
              },
              orderDate: format(item.orderTime, siteInfo.dateFormat),
              price: MathUtils.priceFormat(titlePrice || 0, language),
              ...basePreOrderItem,
              finalizeOrderPreSale: {
                ...basePreOrderItem?.finalizeOrderPreSale,
                orderNo: item.orderNo,
                orderId: item.id,
                membershipDataConfig: preorderTemplate?.fields?.membershipDataConfig
              },
              gearItem: {
                ...baseGearItem
              },
              brandItem: {
                ...pdpItem,
                finalizeOrder: {
                  ...pdpItem?.finalizeOrder,
                  orderDetailRes: { ...item, usePageName: "history" }
                },
                loanApprovedFinalize: {
                  ...pdpItem?.loanApprovedFinalize,
                  orderDetailRes: { ...item, usePageName: "history" }
                },
                loanRejectedFinalize: {
                  ...pdpItem?.loanRejectedFinalize,
                  orderDetailRes: { ...item, usePageName: "history" }
                }
              }
            };
          });
          setOrders(_orders);
          setOrdersTotal(res.obj.total);
          setIsShowHaveNoOrder(true);
        }
      })
      .catch(err => {
        console.log("get orders error:", err);
      });
  };
  const orderItemLabels = preorderTemplate?.fields.items.map(i => ({
    key: i.fields.key.value,
    value: i.fields.phrase.value
  }));
  const gearItemLabels = gearTemplate?.fields.items.map(i => ({
    key: i.fields.key.value,
    value: i.fields.phrase.value
  }));
  const pdpItemLabels = pdpTemplate?.fields.items.map(i => ({
    key: i.fields.key.value,
    value: i.fields.phrase.value
  }));
  const basePreOrderItem = {
    body: preorderTemplate?.fields.body.value,
    link1: {
      colorScheme: preorderTemplate?.fields.receiptColorScheme,
      iconName: preorderTemplate?.fields.receiptIconName,
      link: {
        value: {
          text: preorderTemplate?.fields.buttonText.value,
          href: ``, // build a link to pdf receipt
          target: "_blank"
        }
      }
    },
    invoiceLink: {
      colorScheme: preorderTemplate?.fields.invoiceDocumentColorScheme,
      iconName: preorderTemplate?.fields.invoiceDocumentIconName,
      link: {
        value: {
          text: preorderTemplate?.fields.invoiceDocumentButtonText.value,
          href: "",
          target: "_blank"
        }
      }
    },
    link2: preorderTemplate?.fields.membershipLink?.fields,
    finalizeOrderPreSale: {
      heading: {
        html: preorderTemplate?.fields.finalizeOrderHeadingBody,
        type: preorderTemplate?.fields.finalizeOrderHeadingType
      },
      overviewHeading: preorderTemplate?.fields.finalizeOrderOverviewText,
      overviewBody: preorderTemplate?.fields.finalizeOrderOverviewBody,
      button: preorderTemplate?.fields.finalizeOrderButton?.fields
    },
    orderItemLabels,
    lang
  };

  const pdpItem = {
    moreInfo: pdpTemplate?.fields?.moreInfo,
    finalizeOrder: {
      overviewHeading: pdpTemplate?.fields?.finalizeOrderheading,
      overviewBody: pdpTemplate?.fields?.finalizeOrderBody,
      button: pdpTemplate?.fields?.finalizeOrderButton?.fields
    },
    loanApprovedFinalize: {
      overviewHeading: pdpTemplate?.fields?.loanApprovedOrderheading,
      overviewBody: pdpTemplate?.fields?.loanApprovedOrderBody,
      button: pdpTemplate?.fields?.loanApprovedOrderButton?.fields
    },
    loanRejectedFinalize: {
      overviewHeading: pdpTemplate?.fields?.loanRejectedOrderheading,
      overviewBody: pdpTemplate?.fields?.loanRejectedOrderBody,
      button: pdpTemplate?.fields?.loanRejectedOrderButton?.fields
    },
    santanderButton: pdpTemplate?.fields?.santanderButton?.fields,
    invoiceLink: {
      colorScheme: pdpTemplate?.fields.invoiceDocumentColorScheme,
      iconName: pdpTemplate?.fields.invoiceDocumentIconName,
      link: {
        value: {
          text: pdpTemplate?.fields.invoiceDocumentButtonText.value,
          href: "",
          target: "_blank"
        }
      }
    },
    body: pdpTemplate?.fields.body.value,
    receiptLink: pdpTemplate?.fields?.receiptLink?.fields,
    pdpItemLabels,
    detailsItem: pdpTemplate?.fields.details,
    yesValue: pdpTemplate?.fields.yesValue?.value,
    detailsLink: pdpTemplate?.fields?.detailsLink?.fields
  };
  const baseGearItem = {
    moreInfo: "",
    body: gearTemplate?.fields.body.value,
    link1: {
      colorScheme: gearTemplate?.fields.receiptColorScheme,
      iconName: gearTemplate?.fields.receiptIconName,
      link: {
        value: {
          text: gearTemplate?.fields.buttonText.value,
          href: "", // build a link to pdf receipt
          target: "_blank"
        }
      }
    },
    invoiceLink: {
      colorScheme: gearTemplate?.fields.invoiceDocumentColorScheme,
      iconName: gearTemplate?.fields.invoiceDocumentIconName,
      link: {
        value: {
          text: gearTemplate?.fields.invoiceDocumentButtonText.value,
          href: "",
          target: "_blank"
        }
      }
    },
    detailsItem: gearTemplate?.fields.details,
    gearItemLabels: gearItemLabels,
    lang
  };
  const getReceipts = async () => {
    const siteInfo = await getSiteInfo();
    let receipts = [];
    const res = await api.order.receipt.list(null, {
      displayLength: receiptsTotal,
      displayStart: 0
    });
    (res?.obj?.data || []).forEach(dataItem => {
      let language = dataItem?.country ? `${dataItem?.language}-${dataItem?.country}` : dataItem?.language;
      let _orderType = getOrderType(dataItem.orderSubType);
      let pdfReceiptType = _orderType;
      if (_orderType === "gears") {
        pdfReceiptType = "gearssale";
      }
      switch (dataItem.orderSubType) {
        case orderTypes?.monthToMonth:
          pdfReceiptType = planType?.MtM;
          break;
        case orderTypes?.buyACarCash:
          pdfReceiptType = planType?.BaC;
          break;
        default:
          break;
      }

      let receiptLink = appendQuery(`/${lang}/PdfView`, {
        orderNo: dataItem?.orderNo,
        paymentNo: dataItem?.paymentNo,
        orgId: dataItem?.orgId,
        pdfCode: dataItem?.receiptPdfCode,
        lang: dataItem?.language
      });
      let item = {
        date: format(Number(dataItem?.invoiceDate), siteInfo.dateFormat),
        receiptNumber: dataItem?.receiptNo,
        amount: MathUtils.priceFormat(dataItem?.receiptAmount, language),
        invoiceLink: dataItem?.pspInvoiceLink,
        receiptLink: receiptLink
      };
      receipts.push(item);
    });
    setTotalReceipts(res.obj?.total || 0);
    setReceipts(receipts);
  };
  const loadMoreReceipts = () => {
    const currentTotal = receipts.length;
    if (currentTotal < receiptsTotal) {
      getReceipts();
    } else {
      setShowMoreReceipts(true);
    }
  };
  const receiptsLinkCallBack = (type, item) => {
    let newUrl = "/";
    switch (type) {
      case "receipt":
        newUrl = item?.receiptLink ? `${window.location.origin}${item?.receiptLink}` : "/";
        window.open(newUrl);
        break;
      case "invoice":
        newUrl = item?.invoiceLink;
        window.open(newUrl);
        break;
      default:
        break;
    }
  };
  return (
    <MyAccountTemplate
      heroConfiguration={
        hero[0]?.fields
          ? {
              ...hero[0].fields,
              titleBody: genrateHeadingWithFirstName(hero[0].fields.titleBody, firstName)
            }
          : {}
      }
      menu={accountMenu ? accountMenu[0]?.fields : {}}
      datasourceid={rendering.dataSource}
    >
      <div className="my-account-orders">
        {pageConfiguration.heading && pageConfiguration.body && orders?.length > 0 && (
          <section className="orders-heading-body">
            <Heading {...pageConfiguration.heading} />
            <BodyText html={pageConfiguration.body} />
          </section>
        )}

        <section className={orderClasses}>
          {orders &&
            orders.slice(0, numberOfItems).map((order, index) => (
              <AccordionWrapper {...order} key={index}>
                <div className="order-content"></div>
              </AccordionWrapper>
            ))}
          {orders.length > 0 && !showMore && ordersTotal > numberOfItems && (
            <div className="show-more">
              <PrimaryButton
                {...{
                  ...pageConfiguration.showMoreButton,
                  callback: () => {
                    setShowMore(true);
                    getOrders();
                  }
                }}
              />
            </div>
          )}

          {orders?.length <= 0 && isShowHaveNoOrder && (
            <>
              <Heading {...pageConfiguration.noOrders.heading} typographyClass="type-h3" className="title" />
              <BodyText html={pageConfiguration.noOrders.body} />
              {goToPresalesButton && <PrimaryButton {...pageConfiguration.noOrders.cta} />}
            </>
          )}
        </section>
      </div>

      <div className={receiptClasses}>
        {receipts?.length > 0 && (
          <>
            <section className="orders-heading-body">
              <Heading {...receiptConfiguration.heading} />
              <BodyText html={receiptConfiguration.body} />
            </section>
            <AllReceiptsTable
              receipts={receipts}
              dateLabel={dateLabel.value}
              amountLabel={amountLabel.value}
              receiptsNumberLabel={receiptsNumberLabel.value}
              invoiceLabel={invoiceLabel.value}
              receiptLabel={receiptLabel.value}
              receiptLinkLabel={receiptLinkLabel.value}
              invoiceLinkLabel={invoiceLinkLabel.value}
              linkCallback={receiptsLinkCallBack}
              numberOfItemToshow={numberOfReceiptToShow.value}
            />
            {!showMoreReceipts && receiptsTotal > receipts.length && (
              <div className="show-more-receipts">
                <PrimaryButton
                  {...{
                    ...receiptConfiguration.showMoreButton,
                    callback: () => {
                      loadMoreReceipts();
                    }
                  }}
                />
              </div>
            )}
          </>
        )}
        {receipts?.length <= 0 && (
          <>
            <Heading {...pageConfiguration.noReceipts.heading} typographyClass="type-h3" className="title" />
            <BodyText html={pageConfiguration.noReceipts.body} />
          </>
        )}
      </div>
    </MyAccountTemplate>
  );
};

MyAccountOrders.propTypes = {
  heroConfiguration: PropTypes.object,
  menu: PropTypes.object,
  pageConfiguration: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.string,
    paymentMethod: PropTypes.shape({
      heading: PropTypes.object,
      body: PropTypes.string
    }),
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.object,
        description: PropTypes.string,
        body: PropTypes.string,
        open: PropTypes.bool,
        link1: PropTypes.object,
        link2: PropTypes.object,
        status: PropTypes.shape({
          text: PropTypes.string,
          icon: PropTypes.string
        }),
        items: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.string,
            html: PropTypes.bool,
            type: PropTypes.oneOf(["GearOrders"]),
            orderItems: PropTypes.array
          })
        )
      })
    ),
    showMoreButton: PropTypes.object,
    noOrders: PropTypes.shape({
      heading: PropTypes.object,
      body: PropTypes.string,
      cta: PropTypes.object
    })
  })
};
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state),
  user: selectUserState(state)
});

export default connect(mapStateToProps)(MyAccountOrders);
